<script>
    export let event;
</script>

{#if event.line_up && event.line_up.length}
    <small>Line-up</small>
    <div class="overflow-auto height-25">
        <ul class="list-unstyled">
            {#each event.line_up as { artist }}
                <li>{artist.name}</li>
            {/each}
        </ul>
    </div>
{/if}